import React, { useEffect, useState } from "react";
import {
	Datagrid,
	List,
	NumberField,
	ReferenceField,
	TextField,
	useDataProvider,
	useRecordContext
} from "react-admin";
import { LinearProgress, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

const UserField = () => {
	const record = useRecordContext();
	const dataProvider = useDataProvider();
	const [user, setUser] = useState();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState();

    useEffect(() => {
        setLoading(true);
        setError();
        setUser();
        dataProvider.getList('user', {pagination: {page: 1, perPage: 1}, sort: {field: "uid", order: "asc"}, filter: {uid: record?.user_uid}})
            .then(({data}) => {
                setUser(data[0]);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            })
    }, [record]);

	if (loading) return <LinearProgress />;
	if (error)
		return (
			<ErrorIcon
				aria-errormessage={error.message ? error.message : error}
				role="presentation"
				color="error"
				fontSize="small"
			/>
		);
	if (!user) return null;

	return (
		<Typography component="span" variant="body2">
			{user.email}
		</Typography>
	);
};

const FundraisersCampaignList = (props) => {
	return (
		<List
			sort={{
				field: "id",
				order: "DESC",
			}}
			{...props}
		>
			<Datagrid rowClick="edit">
				<NumberField source="id" label="Id" />
				<TextField source="description" label="Titre" />
				<ReferenceField
					label="Campagne"
					source="campaign_id"
					reference="campaign"
					basePath="/campaign"
					link="show"
				>
					<TextField source="abstract_title" />
				</ReferenceField>
				<TextField source="amount" label="Objectif" />
				<UserField label="Créateur" />
			</Datagrid>
		</List>
	);
};

export default FundraisersCampaignList;
